import React from "react";
import ServiceItem from "./ServiceItem";
import ServiceProgressArea from "./ServiceProgressArea";
import { Link } from "react-router-dom";
import HomeData from "../../../data/home.json";
function ServiceWrap() {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <>
      <div className="service-section pt-120 pb-120">
        <div className="container">
          <div className="row mb-4 pb-3 d-flex justify-content-lg-start justify-content-center align-items-center">
            <div className="col-lg-8  text-lg-start text-center">
              <div
                className="section-title2 wow animate fadeInDown"
                data-wow-duration="1.5s"
                data-wow-delay="0.5s"
              >
                <h2 className="cusm-front" >Our Solution</h2>
               
              </div>
            </div>

          </div>
          {/* MOBILE  */}
          <div className="row d-flex justify-content-center g-4">

            <div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">


              <div className="col-md-7 col-sm-6 ">
                <h3
                  style={{ color: "#cf2534", textAlign: "initial" }}
                  className=" cusm-front  text-just"
                >
                  Mobile App Development
                </h3>


                <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
                  Genius Fixers offers a comprehensive suite of Mobile App Development Solutions to help businesses stay competitive in the digital age. Their team of experienced developers builds custom mobile applications for Android and iOS platforms, tailored to meet the specific needs of their clients. With an emphasis on quality and user experience, Genius Fixers creates mobile apps that are intuitive, responsive, and engaging. Whether it's a consumer-facing app or an enterprise-grade solution, Genius Fixers can help businesses of all sizes take advantage of the tremendous opportunities offered by mobile technology.

                </p>




              </div>

              <div className="col-md-5 col-sm-5">
                <img
                  style={{ height: "100%;", width: "100%" }}
                  src={
                    process.env.PUBLIC_URL + "./images/bg/mobile-app-development.png"
                  }
                  alt="images"
                />
              </div>


            </div>




          </div>

          {/* WEB */}
          <div className="row d-flex justify-content-center g-4"> 

<div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">

<div className="col-md-5 col-sm-5">
    <img
      style={{ height: "100%;", width: "100%" }}
      src={
        process.env.PUBLIC_URL + "./images/bg/web-app-development.png"
      }
      alt="images"
    />
  </div>
  <div className="col-md-7 col-sm-6 ">
    <h3
      style={{ color: "#cf2534", textAlign: "initial" }}
      className=" cusm-front  text-just"
    >
      Web App Development 
    </h3>


    <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
    At Genius Fixers, we specialize in providing end-to-end web app development solutions to businesses of all sizes. Our team of expert developers has a proven track record of delivering high-quality, customized web applications that are designed to meet your unique business needs. We use the latest technology and development frameworks to ensure that your web app is scalable, secure, and user-friendly. Our focus is on delivering exceptional user experiences, improving efficiency, and maximizing ROI. Let us help you take your business to the next level with our web app development services.
    </p>




  </div>
  



</div>




          </div>

          {/* BLOCK */}
          <div className="row d-flex justify-content-center g-4">

<div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">


  <div className="col-md-7 col-sm-6 ">
    <h3
      style={{ color: "#cf2534", textAlign: "initial" }}
      className=" cusm-front  text-just"
    > 
    Block Chain Development
    </h3>


    <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
    Genius Fixers provides cutting-edge Block Chain development solutions that can help businesses streamline their operations, enhance security, and improve transparency. Our team of Block Chain developers has extensive experience in developing custom Block Chain solutions for various industries such as finance, healthcare, logistics, and more. We use the latest Block Chain technology and frameworks to ensure that your Block Chain solution is scalable, secure, and cost-effective. Our focus is on delivering solutions that maximize efficiency, reduce costs, and increase profitability. Let us help you transform your business with our Block Chain development services.

    </p>




  </div>

  <div className="col-md-5 col-sm-5">
    <img
      style={{ height: "100%;", width: "100%" }}
      src={
        process.env.PUBLIC_URL + "./images/bg/block-chain-development.png"
      }
      alt="images"
    />
  </div>


</div>




          </div>

          {/*  SASS */}
          <div className="row d-flex justify-content-center g-4"> 

<div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">

<div className="col-md-5 col-sm-5">
    <img
      style={{ height: "100%;", width: "100%" }}
      src={
        process.env.PUBLIC_URL + "./images/bg/saas-development.png"
      }
      alt="images"
    />
  </div>
  <div className="col-md-7 col-sm-6 ">
    <h3
      style={{ color: "#cf2534", textAlign: "initial" }}
      className=" cusm-front  text-just"
    >
 SaaS Development
    </h3>


    <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
    At Genius Fixers, we specialize in providing end-to-end SaaS development solutions to businesses of all sizes. Our team of experienced developers has a proven track record of delivering high-quality, customized SaaS solutions that are designed to meet your unique business needs. We use the latest technology and development frameworks to ensure that your SaaS solution is scalable, secure, and user-friendly. Our focus is on delivering exceptional user experiences, improving efficiency, and maximizing ROI. Let us help you take your business to the next level with our SaaS development services. 
    </p>




  </div>
  



</div>




          </div>
          {/* Robotic */}
          <div className="row d-flex justify-content-center g-4">

<div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">


  <div className="col-md-7 col-sm-6 ">
    <h3
      style={{ color: "#cf2534", textAlign: "initial" }}
      className=" cusm-front  text-just"
    > 
Robotic Process Automation (RPA)
    </h3>


    <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
    Genius Fixers offers Robotic Process Automation (RPA) solutions to help businesses automate repetitive tasks and streamline their operations. Our team of RPA experts has extensive experience in developing custom RPA solutions for various industries such as finance, healthcare, logistics, and more. We use the latest RPA technology and frameworks to ensure that your RPA solution is scalable, secure, and cost-effective. Our focus is on delivering solutions that improve efficiency, reduce errors, and increase profitability. Let us help you transform your business with our RPA solutions. 

    </p>




  </div>

  <div className="col-md-5 col-sm-5">
    <img
      style={{ height: "100%;", width: "100%" }}
      src={
        process.env.PUBLIC_URL + "./images/bg/robotic-process-automation.png"
      }
      alt="images"
    />
  </div>


</div>




          </div>
          {/* Live */}
          <div className="row d-flex justify-content-center g-4"> 

<div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">

<div className="col-md-5 col-sm-5">
    <img
      style={{ height: "100%;", width: "100%" }}
      src={
        process.env.PUBLIC_URL + "./images/bg/live-video-streaming-app.png"
      }
      alt="images"
    />
  </div>
  <div className="col-md-7 col-sm-6 ">
    <h3
      style={{ color: "#cf2534", textAlign: "initial" }}
      className=" cusm-front  text-just"
    >
      Live Video Streaming App  
    </h3>


    <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
    Genius Fixers specializes in developing high-quality live video streaming app solutions that are designed to meet your specific business needs. Our team of expert developers has extensive experience in delivering cutting-edge live video streaming solutions for a variety of industries, including media, entertainment, and education. We use the latest technology and development frameworks to ensure that your live video streaming app is user-friendly, secure, and scalable. Our focus is on delivering exceptional user experiences, improving engagement, and maximizing ROI. Let us help you take your business to the next level with our live video streaming app solutions.  
    </p>




  </div>
  



</div>




          </div>



          {/* CLOUD */}
          <div className="row d-flex justify-content-center g-4">

<div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">


  <div className="col-md-7 col-sm-6 ">
    <h3
      style={{ color: "#cf2534", textAlign: "initial" }}
      className=" cusm-front  text-just"
    > 
Cloud Consulting
    </h3>


    <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
    At Genius Fixers, we offer comprehensive cloud consulting solutions to help businesses of all sizes migrate to the cloud, optimize their cloud infrastructure, and ensure maximum ROI. Our team of experienced cloud consultants has extensive experience in working with cloud platforms such as AWS, Azure, and Google Cloud. We take a customized approach to each project, ensuring that our solutions are tailored to meet your specific business needs. Our focus is on delivering solutions that improve efficiency, reduce costs, and increase agility. Let us help you unlock the full potential of the cloud with our cloud consulting solutions.

    </p>




  </div>

  <div className="col-md-5 col-sm-5">
    <img
      style={{ height: "100%;", width: "100%" }}
      src={
        process.env.PUBLIC_URL + "./images/bg/cloud-consulting.png"
      }
      alt="images"
    />
  </div>


</div>




          </div>


          {/* DATA SCIENCE  */}
          <div className="row d-flex justify-content-center g-4"> 

<div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">

<div className="col-md-5 col-sm-5">
    <img
      style={{ height: "100%;", width: "100%" }}
      src={
        process.env.PUBLIC_URL + "./images/bg/data-science-consulting.png"
      }
      alt="images"
    />
  </div>
  <div className="col-md-7 col-sm-6 ">
    <h3
      style={{ color: "#cf2534", textAlign: "initial" }}
      className=" cusm-front  text-just"
    >
Data Science Consulting 
    </h3>


    <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
    At Genius Fixers, we offer comprehensive data science consulting solutions to help businesses of all sizes harness the power of data. Our team of experienced data scientists and analysts has extensive experience in working with data analytics, machine learning, and artificial intelligence. We take a customized approach to each project, ensuring that our solutions are tailored to meet your specific business needs. Our focus is on delivering solutions that improve efficiency, reduce costs, and increase revenue. Whether you need help with data analytics, predictive modeling, or AI development, we have the expertise to help you achieve your goals. Let us help you unlock the full potential of your data with our data science consulting solutions
    </p>




  </div>
  



</div>




          </div>


        {/* Virtual Reality */}
        <div className="row d-flex justify-content-center g-4">

<div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">


  <div className="col-md-7 col-sm-6 ">
    <h3
      style={{ color: "#cf2534", textAlign: "initial" }}
      className=" cusm-front  text-just"
    > 
Virtual Reality Development
    </h3>


    <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
    At Genius Fixers, we specialize in delivering innovative virtual reality development solutions to help businesses engage their customers and enhance their brand experiences. Our team of expert VR developers has extensive experience in developing customized VR solutions for a variety of industries, including gaming, healthcare, and education. We use the latest VR development tools and techniques to ensure that your VR app is immersive, interactive, and user-friendly. Our focus is on delivering solutions that improve customer engagement, increase revenue, and enhance brand loyalty. Let us help you create unforgettable VR experiences for your customers with our VR development solutions. 

    </p>




  </div>

  <div className="col-md-5 col-sm-5">
    <img
      style={{ height: "100%;", width: "100%" }}
      src={
        process.env.PUBLIC_URL + "./images/bg/virtual-reality-development.png"
      }
      alt="images"
    />
  </div>


</div>




        </div>

        {/* SQA */}
        <div className="row d-flex justify-content-center g-4"> 

<div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">

<div className="col-md-5 col-sm-5">
    <img
      style={{ height: "100%;", width: "100%" }}
      src={
        process.env.PUBLIC_URL + "./images/bg/software-quality-assurance.png"
      }
      alt="images"
    />
  </div>
  <div className="col-md-7 col-sm-6 ">
    <h3
      style={{ color: "#cf2534", textAlign: "initial" }}
      className=" cusm-front  text-just"
    >
SQA Software Quality Assurance
    </h3>


    <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
    At Genius Fixers, we offer comprehensive software quality assurance (SQA) solutions to help businesses ensure that their software is reliable, functional, and user-friendly. Our team of experienced SQA professionals has a deep understanding of software development lifecycles and the latest SQA methodologies. We take a proactive approach to testing, identifying issues before they become problems, and providing actionable feedback to improve software performance. Our focus is on delivering solutions that improve software quality, reduce development time and costs, and increase user satisfaction. Whether you need help with functional testing, performance testing, or usability testing, we have the expertise to help you achieve your software quality goals. Let us help you improve the quality of your software with our SQA solutions.
    </p>




  </div>
  



</div>




        </div>

        {/* IOT */}
        <div className="row d-flex justify-content-center g-4">

<div className="service-item  light-mode hover-btn row g-3 service-intro-row mt-5">


  <div className="col-md-7 col-sm-6 ">
    <h3
      style={{ color: "#cf2534", textAlign: "initial" }}
      className=" cusm-front  text-just"
    > 
IoT App Development
    </h3>


    <p className="para mt-md-2 color-black cusm-front text_jus cusm-lineheight">
    At Genius Fixers, we specialize in developing IoT app development solutions that help businesses connect their devices, collect data, and gain valuable insights into their operations. Our team of expert IoT developers has extensive experience in delivering customized IoT solutions for a variety of industries, including healthcare, manufacturing, and retail. We use the latest technology and development frameworks to ensure that your IoT app is user-friendly, secure, and scalable. Our focus is on delivering solutions that improve efficiency, reduce costs, and increase productivity. Let us help you transform your business with our IoT app development solutions.

    </p>




  </div>

  <div className="col-md-5 col-sm-5">
    <img
      style={{ height: "100%;", width: "100%" }}
      src={
        process.env.PUBLIC_URL + "./images/bg/iot-app-development.png"
      }
      alt="images"
    />
  </div>


</div>




        </div>

        </div>

      </div>
    </>
  );
}

export default ServiceWrap;
